import React from 'react'
import { Flex, Card, Typography } from 'antd'
import { Droppable } from 'react-beautiful-dnd'
import ToolCard from './ToolCard'
import { useThemeColors } from '../../../../../../hooks/useThemeColors'

const { Text } = Typography

const PrioritySection = ({ 
    priority, 
    tools, 
    getBoosterDetails, 
    onRemoveTool, 
    isRemoving 
}) => {
    const colors = useThemeColors()
    const isEmpty = tools.length === 0

    return (
        <Card 
            key={priority}
            style={{ marginBottom: 16 }}
            title={
                <Flex gap={8} align='center'>
                    <Text strong>Priority {priority}</Text>
                    <Text type='secondary'>({tools.length} tool{tools.length !== 1 ? 's' : ''})</Text>
                </Flex>
            }
            size='small'
        >
            <Droppable droppableId={String(priority)}>
                {(provided, snapshot) => (
                    <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        style={{
                            minHeight: isEmpty ? 60 : 'auto',
                            backgroundColor: snapshot.isDraggingOver ? colors.hoverBg : undefined,
                            border: snapshot.isDraggingOver ? `2px dashed ${colors.primary}` : isEmpty ? `2px dashed ${colors.borderColor}` : 'none',
                            borderRadius: 6,
                            padding: isEmpty ? 16 : 0,
                            transition: 'all 0.2s ease',
                        }}
                    >
                        {isEmpty ? (
                            <Flex justify='center' align='center' style={{ height: 28 }}>
                                <Text type='secondary'>
                                    {snapshot.isDraggingOver ? 'Drop tool here' : 'Drag tools here'}
                                </Text>
                            </Flex>
                        ) : (
                            tools.map((tool, index) => (
                                <ToolCard
                                    key={tool.senseBoosterId}
                                    tool={tool}
                                    index={index}
                                    boosterDetails={getBoosterDetails(tool.senseBoosterId)}
                                    onRemove={onRemoveTool}
                                    isRemoving={isRemoving}
                                />
                            ))
                        )}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </Card>
    )
}

export default PrioritySection